import { Provider, Injector } from '@angular/core';
import { GOOGLE_AUTH_WARNING_STORAGE } from '../tokens/google-auth-warning-storage.token';
import { IGoogleAuthWarningStorageService } from '@app/models/objects/google-auth-warning-storage.model';
import { LocalStorageGoogleAuthWarningStorageService } from '../services/local-storage-google-auth-warning-storage.service';
import { CookieGoogleAuthWarningStorageService } from '../services/cookie-google-auth-warning-storage.service';
import { isFromMobileApp } from '../helpers';

export function googleAuthWarningStorageFactory(
  injector: Injector,
): IGoogleAuthWarningStorageService {
  return isFromMobileApp()
    ? injector.get(LocalStorageGoogleAuthWarningStorageService)
    : injector.get(CookieGoogleAuthWarningStorageService);
}

export const GOOGLE_AUTH_WARNING_STORAGE_PROVIDER: Provider = {
  provide: GOOGLE_AUTH_WARNING_STORAGE,
  useFactory: googleAuthWarningStorageFactory,
  deps: [Injector],
};
